import { useHistory } from 'react-router-dom'
import properties from '../../../../api/properties/hooks'
import { DataTableLayout, useDataTable, useTableState } from '../../../../Components/TanstackTable'
import useTableColumns from './useTableColumns'

const RelatedPropertiesViewTab = ({ projectId }) => {
    const history = useHistory()
    const tableState = useTableState({ tableKey: 'relatedProperties' })

    const queryParams = {
        ...tableState.params,
        criteria: { project: projectId },
    }

    const { isLoading: fetchingProperties, data: propertiesData } = properties.GetProperties.useQuery(queryParams, { enabled: Boolean(projectId) })

    const columns = useTableColumns()

    const { table } = useDataTable({
        ...tableState,
        columns,
        data: propertiesData?.items ?? [],
        pageCount: propertiesData?.pagination?.totalPages,
    })

    const renderRow = ({ row, children }) =>
        children({
            onClick: () => history.push(`/properties/${row.original.id}`),
            style: { cursor: 'pointer' },
        })

    return (
        <DataTableLayout
            table={table}
            isLoading={fetchingProperties}
            hasColumnSelection
            hasPageSizeSelect
            theadClass="dmn-table-header"
            totalItems={propertiesData?.pagination?.totalItems}
            renderRow={renderRow}
        />
    )
}

export default RelatedPropertiesViewTab
